import React from 'react';

export default function SuperMobileStyles() {
  return (
    <style>{`
      .super-admin-root,
      .super-admin-root * {
        box-sizing: border-box;
      }

      .super-admin-root {
        min-width: 0;
        overflow-x: hidden;
      }

      .super-admin-shell {
        width: 100%;
        max-width: 100vw;
      }

      .super-admin-topbar {
        position: sticky;
        top: 0;
        z-index: 40;
        backdrop-filter: blur(18px);
      }

      .super-admin-nav {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        scroll-snap-type: x proximity;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior-x: contain;
        padding-bottom: 0.15rem;
        scrollbar-width: thin;
      }

      .super-admin-nav a,
      .super-admin-nav button {
        flex: 0 0 auto;
        scroll-snap-align: center;
      }

      .super-admin-main {
        width: 100%;
        max-width: min(100%, 1120px);
        overflow: visible;
      }

      .super-admin-main input,
      .super-admin-main select,
      .super-admin-main textarea,
      .super-admin-main button {
        max-width: 100%;
      }

      .super-admin-main table {
        min-width: 760px;
      }

      .super-mobile-scroll,
      .super-admin-main table,
      .super-admin-main [style*="grid-template-columns"] {
        max-width: 100%;
      }

      .super-admin-main .recharts-wrapper,
      .super-admin-main .recharts-responsive-container {
        max-width: 100% !important;
      }

      @media (max-width: 860px) {
        .super-admin-topbar > div {
          max-width: none !important;
          padding: 0.85rem 0.9rem !important;
          display: grid !important;
          grid-template-columns: 1fr !important;
          gap: 0.75rem !important;
          align-items: stretch !important;
        }

        .super-admin-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.75rem;
          font-size: 1.05rem !important;
        }

        .super-admin-nav {
          margin-left: -0.15rem;
          margin-right: -0.15rem;
          padding: 0.1rem 0.15rem 0.35rem;
          justify-content: flex-start !important;
          flex-wrap: nowrap !important;
        }

        .super-admin-nav a,
        .super-admin-nav button {
          min-height: 2.35rem;
          border-radius: 999px !important;
          padding: 0.62rem 0.9rem !important;
          font-size: 0.78rem !important;
          line-height: 1 !important;
        }

        .super-admin-nav button {
          margin-left: 0 !important;
        }

        .super-admin-main {
          max-width: 100vw !important;
          padding: 1rem !important;
          overflow-x: hidden;
        }

        .super-admin-main h1,
        .super-admin-main h2 {
          font-size: clamp(1.45rem, 7vw, 2.25rem) !important;
          line-height: 1.05 !important;
        }

        .super-admin-main h3 {
          font-size: 1.1rem !important;
        }

        .super-admin-main .grid,
        .super-create-page form,
        .super-support-page .grid,
        .super-usage-page .grid {
          min-width: 0;
        }

        .super-create-page form {
          padding: 1rem !important;
          border-radius: 1.2rem !important;
        }

        .super-create-page form .grid,
        .super-create-page form [class*="grid-cols"],
        .super-support-page [class*="grid-cols"],
        .super-usage-page [class*="grid-cols"] {
          grid-template-columns: minmax(0, 1fr) !important;
        }

        .super-create-page label,
        .super-create-page input,
        .super-create-page select,
        .super-create-page button {
          width: 100%;
        }

        .super-orgs-page > div:first-child,
        .super-support-page > div:first-child,
        .super-usage-page > div:first-child {
          align-items: stretch !important;
        }

        .super-orgs-page > div:first-child > div,
        .super-support-page > div:first-child > div,
        .super-usage-page > div:first-child > div {
          width: 100%;
        }

        .super-orgs-page a,
        .super-orgs-page button,
        .super-support-page button,
        .super-download-page button,
        .super-usage-page button {
          min-height: 2.4rem;
        }

        .super-orgs-page .space-y-3 > div,
        .super-orgs-page .mt-8 .space-y-3 > div {
          display: grid !important;
          grid-template-columns: 1fr !important;
          align-items: stretch !important;
          gap: 0.85rem !important;
        }

        .super-orgs-page .space-y-3 > div > div:last-child,
        .super-orgs-page .mt-8 .space-y-3 > div > div:last-child {
          display: flex !important;
          flex-wrap: wrap !important;
          justify-content: flex-start !important;
          gap: 0.5rem !important;
        }

        .super-support-page > .grid,
        .super-support-page .grid.lg\\:grid-cols-\[370px_minmax\(0\,1fr\)\] {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
        }

        .super-support-page section {
          min-width: 0;
        }

        .super-support-page .max-h-\[620px\] {
          max-height: 42vh !important;
        }

        .super-support-page .text-3xl {
          font-size: 1.45rem !important;
          overflow-wrap: anywhere;
        }

        .super-support-page .text-xl {
          font-size: 1.05rem !important;
        }

        .super-download-page {
          min-width: 0;
          overflow-x: hidden;
        }

        .super-download-page > div[style*="justify-content: space-between"] {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
          align-items: stretch !important;
        }

        .super-download-page > div[style*="justify-content: space-between"] > div:last-child {
          display: flex !important;
          flex-wrap: wrap !important;
          justify-content: flex-start !important;
        }

        .super-download-page [style*="grid-template-columns: 1fr 1fr 1fr"],
        .super-download-page [style*="grid-template-columns: 1fr auto"] {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
        }

        .super-download-page [style*="grid-template-columns: minmax(300px,1.35fr)"] {
          display: none !important;
        }

        .super-download-page input[readonly] {
          min-width: 0;
        }

        .super-download-page canvas {
          max-width: 140px !important;
          height: auto !important;
        }

        .super-usage-page {
          overflow-x: hidden;
        }

        .super-usage-page table,
        .super-usage-page [role="table"] {
          min-width: 860px;
        }

        .super-usage-page .overflow-x-auto,
        .super-usage-page [class*="overflow-x-auto"] {
          -webkit-overflow-scrolling: touch;
        }

        .super-admin-main .fixed.inset-0 > div,
        .super-admin-main [class*="fixed"][class*="inset-0"] > div {
          max-width: calc(100vw - 1.5rem) !important;
          max-height: calc(100dvh - 1.5rem) !important;
          overflow: auto !important;
          border-radius: 1.25rem !important;
        }
      }

      @media (max-width: 520px) {
        .super-admin-main {
          padding: 0.75rem !important;
        }

        .super-admin-nav a,
        .super-admin-nav button {
          font-size: 0.72rem !important;
          padding-inline: 0.75rem !important;
        }

        .super-support-page .grid.grid-cols-2,
        .super-support-page .md\\:grid-cols-5 {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }

      @media (orientation: landscape) and (max-height: 540px) {
        .super-admin-topbar {
          position: relative;
        }

        .super-admin-main {
          padding-top: 0.75rem !important;
        }
      }
    `}</style>
  );
}
